import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { clone, dropLast, last, pathOr } from 'ramda';
/**
 * Объединяет шаг с дополнительными аргументами
 * Используется при сложных ветвлениях, когда от условия ветвления
 * зависит отображение шага или валидация
 */
export var mergeStepArgs = function mergeStepArgs(step, nextStepArgs) {
  var mergedStep = clone(step);
  nextStepArgs.forEach(function (arg) {
    if (!arg.path.length) {
      return;
    }
    var path = dropLast(1, arg.path);
    var item = last(arg.path);
    var parent = pathOr(_defineProperty({}, item, null), path, mergedStep.question);
    parent[item] = arg.value;
  });
  return mergedStep;
};